import { useSiteCountryCode } from '@common/hooks/localisation';

export function useGetAccountLink() {
  const countryCode = useSiteCountryCode();

  return `/${countryCode}/account`;
}
